<template lang="pug">
div(
    v-show="componentDisplay.isVisible"
    :class="{ 'relative': $storyblok.isEditing }"
)
    component(v-bind="componentDisplay.component")

    //- Shade for storyblok editor to prevent clicks
    div(
        v-if="$storyblok.isEditing"
        class="absolute inset-0 z-50"
    )
</template>

<script>
import FitmentInline from '@/components/fitment/fitmentInline'
import SameDayShippingInline from '@/components/shipping/sameDayShippingInline'

export default {
    name: 'FitmentWidget',
    components: {
        FitmentInline,
        SameDayShippingInline,
    },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        hasFullFitment() {
            return this.$store.getters['fitment/hasFullFitment']
        },
        hasSiteWideDefaultFullFitment() {
            return this.$store.getters['fitment/hasSiteWideDefaultFullFitment']
        },
        componentDisplay() {
            const options = {
                component: {
                    is: FitmentInline,
                },
                isVisible: !this.hasFullFitment,
            }

            if (
                this.data.display === 'SAME_DAY' &&
                this.$config.runtime.theme.sameDayShipping.enabled
            ) {
                options.component.is = SameDayShippingInline
                options.component.fitmentButtonColor = this.data.color
                options.isVisible = !this.hasSiteWideDefaultFullFitment
            }

            return options
        },
    },
}
</script>
